import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {MetricsStore} from '../../../../shared/store/quickDashboard/metrics.store';
import {QuickDashboardMetric} from '../../../../shared/interfaces/quick-dashboard';

@Component({
  selector: 'app-metrics',
  templateUrl: './metrics.component.html',
  styleUrls: ['./metrics.component.scss'],
  providers: [MetricsStore]
})
export class MetricsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() public slugs: Array<string> = [];

  public templateColumns: string;

  public readonly data$: Observable<{ [key: string]: QuickDashboardMetric }> = this._metricsStore.data$;
  public readonly loading$: Observable<boolean> = this._metricsStore.loading$;

  constructor(
    private readonly _metricsStore: MetricsStore
  ) { }

  ngOnInit(): void {
    this.templateColumns = this.getTemplateColumns();
  }

  ngAfterViewInit(): void {
    this.load();
  }

  ngOnDestroy(): void {}

  public reload() {
    this.load();
  }

  private load(): void {
    this._metricsStore.load(this.slugs);
  }

  public getTemplateColumns(): string {
    let template: string = '';

    for (const slug of this.slugs) {
      template += ' 1fr';
    }

    return template;
  }

}
